export default __webpack_public_path__ + "static/media/IC00033-languages.6a978fbc.svg";